import React from 'react';

import { IndexRoute, Route } from 'react-router';

import ChangelogWidget404 from './ChangelogWidget404';
import ChangelogWidgetContainer from './ChangelogWidgetContainer';
import ChangelogWidgetEntry from './ChangelogWidgetEntry';
import ChangelogWidgetHome from './ChangelogWidgetHome';

export default (
  <Route path=":companyID" component={ChangelogWidgetContainer}>
    <IndexRoute component={ChangelogWidgetHome} />
    <Route path=":entryURLName" component={ChangelogWidgetEntry} />
    <Route path="*" component={ChangelogWidget404} />
  </Route>
);
